/**
 * @author Sasanka Weerakoon
 * @version 0.0.1
 * @since 21/4/2025
 */

import React, { useRef, useState, useEffect } from "react";
import Box from "@mui/material/Box";
import { Stack, FormControl, Button } from "@mui/material";
import Select from "react-select";
import api from "../../../../base/services/ResApi";
import Alerts from "../../../../base/errorHandeling/Alerts";
import { FetchErrorHandeling } from "../../../../base/errorHandeling/FetchErrorHandeling";
import OrganizationReportTable from "./OrganizationReportTable";
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';

const OrganizationReport = () => {

    const selectOrgRef = useRef(null);

    const [data, setData] = useState([]);
    const [orgType, setOrgType] = useState("");

    const [loading, setLoading] = useState(false);

    const [isSuccess, setIsSuccess] = useState(false)
    const [successMessages, setSuccessMessages] = useState([])

    const [isError, setIsError] = useState(false)
    const [isErrorShow, setIsErrorShow] = useState(false)
    const [errorMessages, setErrorMessages] = useState([])

    const orgTypeOptions = [
        { value: "V_ALL_ORG", label: "All Organizations" },
        { value: "V_APPR_ORG", label: "All Approved Organizations" },
        { value: "V_NON_APPR_ORG", label: "All Non Approved Organizations" },
    ];

    useEffect(() => {
        if (isError === true) {
            setTimeout(() => {
                setIsError(false)
                setErrorMessages([])
            }, 10000)
        }
    }, [isError])

    useEffect(() => {
        if (isSuccess === true) {
            setTimeout(() => {
                setIsSuccess(false)
                setSuccessMessages([])
            }, 3000)
        }
    }, [isSuccess])


    let orgConfig = {
        headers: {
            Action: orgType ?? "V_ALL_ORG",
            "Sort-Column": "org_code",
            "Sort-Order": "asc",
        },
    }


    const fetchOrgReportData = () => {
        setLoading(true)
        api
            .get("/organizations", orgConfig)
            .then((res) => {
                setData(res.data?.dataList)
                setLoading(false);
                setErrorMessages([]);
                setIsError(false);
            })
            .catch((err) => {
                setLoading(false);
                FetchErrorHandeling(
                    err,
                    setIsError,
                    setErrorMessages,
                    setIsErrorShow);
            });
    }

    const customStyles = {
        control: (provided) => ({
            ...provided,
            padding: "10px",
        }),
    }

    return (
        <Box
            sx={{ width: "100%" }}>
            <Stack className="report-filters" spacing={4} direction="row">
                <div>
                    <p
                        style={{
                            fontSize: "12px",
                            position: "relative",
                            top: "-9px",
                            left: "10px",
                            background: "#fff",
                            width: "200px",
                            paddingLeft: "5px",
                            zIndex: 99,
                        }}
                    >Organization scope
                    </p>
                    <FormControl
                        required={false}
                        sx={{
                            minWidth: 400,
                            zIndex: 90,
                            position: "relative",
                            top: "-32px",
                            height: 0,
                        }}
                        size="medium"
                    >
                        <Select
                            ref={selectOrgRef}
                            options={orgTypeOptions}
                            value={orgTypeOptions.find((option) => option.value === orgType)}
                            onChange={(selectedOption) =>
                                setOrgType(selectedOption?.value ?? "")
                            }
                            isClearable
                            styles={{
                                ...customStyles,
                                menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                }),
                            }}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                        />
                    </FormControl>
                </div>
            </Stack>

            <Stack className="report-actions" spacing={2} direction="row" sx={{ my: 3 }}>
                <Button
                    variant="contained"
                    color="warning"
                    onClick={fetchOrgReportData}
                    disabled={!orgType}
                    startIcon={<SearchIcon />}
                >
                    Search
                </Button>
                <Button
                    color="error"
                    variant="outlined"
                    onClick={() => {
                        setData([])
                        setOrgType("")
                        setSuccessMessages([])
                        setErrorMessages([])
                        setIsError(false)
                        setIsSuccess(false)
                        selectOrgRef.current.clearValue()
                    }}
                    startIcon={<CloseIcon />}
                >
                    Clear
                </Button>
            </Stack>

            {!isSuccess &&
                <Alerts
                    iserror={isError}
                    errorMessages={errorMessages}
                    isSuccess={isSuccess}
                    successMessages={successMessages}
                    iserrorShow={isErrorShow}
                />
            }

            <OrganizationReportTable
                organizationReportData={data}
                loading={loading}
            />

        </Box>

    )
}

export default OrganizationReport
